import React from "react";
import PendencyPage from "./pendencyPage";

const PendencyContainer = ({ history, match }) => {
  return <PendencyPage history={history} match={match} />
}

export default PendencyContainer;
